var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#20EE82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.21875C10.2681 4.21875 11.4842 4.72249 12.3809 5.61915C13.2775 6.5158 13.7812 7.73193 13.7812 9V13.7812H9C7.73193 13.7812 6.5158 13.2775 5.61915 12.3809C4.72249 11.4842 4.21875 10.2681 4.21875 9C4.21875 7.73193 4.72249 6.5158 5.61915 5.61915C6.5158 4.72249 7.73193 4.21875 9 4.21875ZM11.8688 11.8688V9.04331C11.8688 7.45706 10.6003 6.13912 9.01462 6.13125C8.63556 6.12976 8.25995 6.20333 7.90945 6.3477C7.55895 6.49208 7.2405 6.70441 6.97245 6.97245C6.70441 7.2405 6.49208 7.55895 6.3477 7.90945C6.20333 8.25995 6.12976 8.63556 6.13125 9.01462C6.13912 10.6003 7.45762 11.8688 9.04331 11.8688H11.8688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/sc.21c28011cae5b39edb12359d1ccb1baf.svg";
export { ForwardRef as ReactComponent };